module.exports = __webpack_public_path__ + "img/semi-ajoure.4224c7d.svg";